import { render } from "./CircularProgressComponent.vue?vue&type=template&id=0fe4f8b4"
import script from "./CircularProgressComponent.vue?vue&type=script&lang=js"
export * from "./CircularProgressComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__